<template>
    <div class="collection-controls" :class="{ 'list': !letManage }">

        <button @click="toggleISO()" type="button"
                :class="{ active: isIso }" class="btn btn-outline-secondary me-2 collection-toggle coll-iso">
            <i class="fa-regular fa-magnifying-glass-plus d-none d-sm-inline d-md-none d-xl-inline"></i> ISO
        </button>
        <button v-if="letManage" @click="toggleGrail()" type="button"
                :class="{ active: grail }" class="btn btn-outline-secondary me-4 collection-toggle coll-grail">
            <i class="fa-regular fa-crown d-none d-sm-inline d-lg-none d-xl-inline"></i> Grail
        </button>
        <span v-if="(!letManage && myPinventory.length < 2) || myPinventory.length < 1">
            <a v-if="isTraded" class="btn collection-toggle btn-info"
                    data-bs-toggle="popover" data-bs-trigger="focus" title="Trade Made"
                    data-bs-content="You have made a successful trade with this pin and it will be transferred when shipped.">
                <i class="fa-regular fa-right-left d-none d-sm-inline"></i> Traded</a>
            <a v-else-if="isOffered" class="btn collection-toggle coll-pending"
                    data-bs-toggle="popover" data-bs-trigger="focus" title="Pending Trade"
                    data-bs-content="You have made a pending trade offer with this pin and must wait until the trade offer expires to modify it.">
                <i class="fa-regular fa-right-left d-none d-sm-inline"></i> Pending</a>
            <a v-else-if="hasOffers" class="btn collection-toggle coll-pending"
                    data-bs-toggle="popover" data-bs-trigger="focus" title="Offers Pending"
                    data-bs-content="You have pending trade offers with this pin and must accept or decline offers to modify it.">
                <i class="fa-regular fa-right-left d-none d-sm-inline"></i> Pending</a>
            <a v-else-if="isListed" class="btn collection-toggle coll-pending"
                    data-bs-toggle="popover" data-bs-trigger="focus" title="Trade Listing"
                    data-bs-content="You have listed this pin on a trade board and must wait until the board closes to modify it.">
                <i class="fa-regular fa-right-left d-none d-sm-inline"></i> Listing</a>
            <div v-else class="btn-group">
                <button v-if="isTrader" @click="toggleTrader(0)" type="button"
                        :class="{ active: isTrader }" class="btn btn-outline-secondary collection-toggle coll-trade">
                    <i class="fa-regular fa-right-left d-none d-sm-inline"></i> Trader</button>
                <button v-else @click="toggleOwn(0)" type="button"
                        :class="{ active: isOwned }" class="btn btn-outline-secondary collection-toggle coll-own">
                    <i class="fa-regular fa-circle-check d-none d-sm-inline"></i> OWN</button>
                <button type="button"
                        :class="[{ active: isTrader || isOwned }, { 'coll-trade': isTrader }, { 'coll-own': isOwned && !isTrader }]"
                        class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split collection-toggle"
                        data-bs-toggle="dropdown" data-bs-auto-close="true">
                    <span class="visually-hidden">Toggle Dropdown</span>
                </button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href.prevent="#" @click="toggleTrader(0)" v-bind="shouldModal">Trader</a></li>
                </ul>
            </div>
        </span>

        <a v-if="!letManage && myPinventory.length > 1" :href="url" class="btn btn-success">you own {{ myPinventory.length }}</a>

        <button v-if="letManage && myPinventory.length > 0" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#manageCollection">Manage {{ myPinventory.length }} Pin{{ myPinventory.length > 1 ? 's' : '' }}</button>
        <div v-if="letManage" class="modal" id="manageCollection" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Manage your Collection:</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!--                        <h5 class="card-title text-muted">Pin ID: {{ pin }}</h5>-->
                        <h6 class="card-subtitle mb-2 text-muted">You own {{ myPinventory.length }} of these...</h6>
                        <div v-for="(item, index) in myPinventory" :key="item.id" class="row">
                            <div class="col-12">
                                <div v-if="item.is_traded" class="card">
                                    <div class="card-body">
                                        <div class="card-title"><strong># {{ index + 1 }}</strong></div>
                                        <div class="alert alert-info small">
                                            <h6 class="alert-heading"><i class="fa-regular fa-right-left"></i> Trade Made</h6>
                                            <p>You have made a successful trade with this pin and it will be transferred when shipped.</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="item.is_offered" class="card">
                                    <div class="card-body">
                                        <div class="card-title"><strong># {{ index + 1 }}</strong></div>
                                        <div class="alert alert-danger small">
                                            <h6 class="alert-heading"><i class="fa-regular fa-right-left"></i> Trade Pending</h6>
                                            <p>You have made a pending trade offer with this pin and must wait until the trade offer expires to modify it.</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="item.has_offers" class="card">
                                    <div class="card-body">
                                        <div class="card-title"><strong># {{ index + 1 }}</strong></div>
                                        <div class="alert alert-danger small">
                                            <h6 class="alert-heading"><i class="fa-regular fa-right-left"></i> Pending Offers</h6>
                                            <p>You have pending trade offers with this pin and must accept or decline offers to modify it. <a :href="'/my/listings/' + item.trade_listing[0].id + '/offers'">VIEW OFFERS</a></p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="item.is_listed" class="card">
                                    <div class="card-body">
                                        <div class="card-title"><strong># {{ index + 1 }}</strong></div>
                                        <div class="alert alert-danger small">
                                            <h6 class="alert-heading"><i class="fa-regular fa-right-left"></i> Trade Listing</h6>
                                            <p>You have listed this pin on a trade board and must wait until the board closes to modify it.</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="card">
                                    <div class="card-header">
                                        <strong class="text-own"><i class="fa-regular fa-circle-check"></i> # {{ index + 1 }}</strong>
                                        <button v-if="removeConfirm !== index" @click="removeInit(index)" type="button"
                                                class="btn btn-sm btn-link text-danger remove-pinventory float-end">
                                            <i class="fa-regular fa-trash-can"></i> remove
                                        </button>
                                        <span v-else class="ms-2"><strong>Remove this pin - Are you sure?</strong></span>
                                    </div>
                                    <div v-if="removeConfirm === index" class="card-body">
                                        <div class="text-center">
                                            <button @click="removeConfirm = false" type="button"
                                                    class="btn btn-sm btn-outline-secondary me-4">
                                                keep it
                                            </button>

                                            <button @click="removePinventory(index)" type="button"
                                                    class="btn btn-sm btn-danger">
                                                Remove It!
                                            </button>
                                        </div>
                                    </div>
                                    <div v-else class="card-body">
                                        <div class="d-flex justify-content-between">
                                            <button @click="toggleTrader(index)" type="button"
                                                    :class="{ active: item.is_trader }" class="btn btn-sm btn-outline-secondary collection-toggle coll-trade">
                                                <i class="fa-regular fa-right-left d-none d-sm-inline d-lg-none d-xl-inline"></i> Trader
                                            </button>

                                            <button @click="toggleScrapper(index)" type="button"
                                                    :class="{ active: item.is_scrapper }" class="btn btn-sm btn-outline-secondary collection-toggle coll-scrap">
                                                <i class="fa-regular fa-square-minus d-none d-sm-inline d-lg-none d-xl-inline"></i> Scrapper
                                            </button>

                                            <button @click="toggleAP(index)" type="button"
                                                    :class="{ active: item.prototype === 'AP' }" class="btn btn-sm btn-outline-secondary collection-toggle coll-ap">
                                                Art Proof
                                            </button>

                                            <button @click="togglePP(index)" type="button"
                                                    :class="{ active: item.prototype === 'PP' }" class="btn btn-sm btn-outline-secondary collection-toggle coll-pp">
                                                Pre-Prod
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button @click="addPinventory(false)" type="button"
                                        class="btn btn-sm btn-outline-success">
                                    <i class="fa-solid fa-plus"></i> Add Pin to my Collection
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "PinCollectionControls",
        props: ['pin', 'letManage', 'url', 'pinsearchof', 'collection', 'pinventory'],
        data() {
            return {
                grail: this.collection.length,
                myIso: this.pinsearchof,
                myPinventory: this.pinventory,
                removeConfirm: false
            }
        },
        watch: {
            pinsearchof: function (newVal, oldVal) {
                this.myIso = newVal;
            },
            pinventory: function (newVal, oldVal) {
                this.myPinventory = newVal;
            }
        },
        mounted() {
            //
        },
        created() {
            this.myPinventory.forEach(pinv => {
                let isListed = false,
                    isOffered = false,
                    hasOffers = false,
                    isTraded = false;

                if (pinv.is_trader) {
                    if (pinv.trade_listing.length) {
                        pinv.trade_listing.forEach(listing => {
                            if (listing.board) {
                                isListed = true;
                            }

                            if (listing.offers && listing.offers.length && listing.offers[0].offersCount > 0) {
                                hasOffers = true;
                            }

                            if (listing.trade) {
                                isTraded = true;
                            }
                        });
                    }

                    if (pinv.trade_offer.filter(o => o.declined_at === null && o.unavailable_at === null).length) {
                        isOffered = true;
                        pinv.trade_offer.forEach(offer => {
                            if (offer.trade) {
                                isTraded = true;
                            }
                        });
                    }
                }
                pinv.is_listed = isListed;
                pinv.is_offered = isOffered;
                pinv.has_offers = hasOffers;
                pinv.is_traded = isTraded;
            });
        },
        computed: {
            isIso: function() {
                return this.myIso.length;
            },
            isOwned: function() {
                return this.myPinventory.length;
            },
            isTrader: function() {
                return this.myPinventory.length && this.myPinventory[0].is_trader;
            },
            shouldModal: function() {
                if (this.letManage) {
                    return {
                        'data-toggle': 'modal',
                        'data-target': '#manageCollection'
                    }
                }
            },
            isListed: function() {
                return this.myPinventory.length && this.myPinventory[0].is_listed;
            },
            isOffered: function() {
                return this.myPinventory.length && this.myPinventory[0].is_offered;
            },
            hasOffers: function() {
                return this.myPinventory.length && this.myPinventory[0].has_offers;
            },
            isTraded: function() {
                return this.myPinventory.length && this.myPinventory[0].is_traded;
            }
        },
        methods: {
            toggleISO: function() {
                if (this.isIso) {
                    axios.delete(`/iso/${this.pin}`).catch(error => {
                        this.handleError(error);
                    });
                    this.myIso = [];
                } else {
                    axios.post('/pin-collections', {
                        pin: this.pin,
                        collection: 'iso'
                    }).then(response => {
                        this.myIso = [{'pin_id': this.pin}];
                    }).catch(error => {
                        this.handleError(error);
                    });
                }
            },
            toggleGrail: function() {
                this.grail = !this.grail;

                if (this.grail) {
                    axios.post('/pin-collections', {
                        pin: this.pin,
                        collection: 'grail'
                    }).then(response => {
                        if (response.status === 200) {
                            //
                        }
                    }).catch(error => {
                        this.handleError(error);
                    });
                } else {
                    axios.delete(`/grail/${this.pin}`).catch(error => {
                        this.handleError(error);
                    });
                }
            },
            toggleTrader: function(index) {
                if (this.myPinventory[index]) {
                    this.myPinventory[index].is_trader = !this.myPinventory[index].is_trader;
                    this.updateCollection(index);
                } else {
                    this.addPinventory(true);
                }
            },
            toggleScrapper: function(index) {
                this.myPinventory[index].is_scrapper = !this.myPinventory[index].is_scrapper;
                this.updateCollection(index);
            },
            toggleAP: function(index) {
                this.myPinventory[index].prototype = this.myPinventory[index].prototype === 'AP' ? null : 'AP';
                this.updateCollection(index);
            },
            togglePP: function(index) {
                this.myPinventory[index].prototype = this.myPinventory[index].prototype === 'PP' ? null : 'PP';
                this.updateCollection(index);
            },
            toggleOwn: function (index) {
                if (this.myPinventory[index]) {
                    this.removePinventory(index);
                } else {
                    this.addPinventory(false);
                }
            },
            updateCollection: function(index) {
                axios.put(`/pin-collections/${this.myPinventory[index].id}`, this.myPinventory[index]).then(response => {
                    if (response.status === 200) {
                        //
                    }
                }).catch(error => {
                    this.handleError(error);
                });
            },
            addPinventory: function(trader) {
                let data = { pin: this.pin, trader: trader };

                axios.post(`/pin-collections`, data).then(response => {
                    if (response.status === 200) {
                        this.myPinventory.push(response.data);
                    } else {
                        //
                    }
                }).catch(error => {
                    this.handleError(error);
                });
            },
            removeInit: function(index) {
                this.removeConfirm = index;
            },
            removePinventory: function(index) {
                this.removeConfirm = false;
                if (this.myPinventory[index]) {
                    axios.delete(`/pin-collections/${this.myPinventory[index].id}`).then(response => {
                        if (response.status === 200) {
                            this.myPinventory.splice(index, 1);
                        }
                    }).catch(error => {
                        this.handleError(error);
                    });
                }
            },
            handleError: function(error) {
                if (error.response.status === 401) {
                    window.location.href = '/login?intended='+window.location.pathname;
                } else if (error.response.status === 419) {
                    window.location.reload();
                }
            }
        }
    }
</script>
